import { Action, createReducer, on } from '@ngrx/store';
import * as globalActions from './global.actions';

export interface State {
    appIsInitialised: boolean;
    returnToProcessing: boolean;
}

export const initialState: State = {
    appIsInitialised: false,
    returnToProcessing: false,
};

const reducerSetup = createReducer(
    initialState,

    on(
        globalActions.initialiseApp,
        (state): State => ({
            ...state,
            appIsInitialised: false,
        }),
    ),

    on(
        globalActions.appInitialised,
        (state): State => ({
            ...state,
            appIsInitialised: true,
        }),
    ),
    on(
        globalActions.returnToProcessing,
        (state): State => ({
            ...state,
            returnToProcessing: true,
        }),
    ),
    on(
        globalActions.returnToProcessed,
        (state): State => ({
            ...state,
            returnToProcessing: false,
        }),
    ),
);

export function reducer(state: State | undefined, action: Action) {
    return reducerSetup(state, action);
}
